import { fmtCurrency } from "../../lib/format";

function Row({ label, value, indent, header, bold, neg, highlight, subtle }) {
  if (header) {
    return (
      <tr>
        <td colSpan={2} className="px-6 pt-5 pb-1 text-[11px] uppercase tracking-[0.15em] text-brand-tertiary">{label}</td>
      </tr>
    );
  }
  return (
    <tr className={`${highlight ? "bg-brand-ink" : ""} ${bold && !highlight ? "border-t border-brand-border" : ""}`}>
      <td className={`px-6 py-2.5 ${indent ? "pl-12" : ""} ${highlight ? "text-brand-page" : bold ? "text-brand-ink font-medium" : subtle ? "text-brand-tertiary" : "text-brand-muted"}`}>{label}</td>
      <td className={`px-6 py-2.5 text-right font-mono ${highlight ? "text-brand-page font-medium" : neg ? "text-brand-neg" : bold ? "text-brand-ink font-medium" : "text-brand-muted"}`}>
        {neg ? `-${fmtCurrency(Math.abs(value))}` : fmtCurrency(value)}
      </td>
    </tr>
  );
}

export default function PnLStatement({ summary, consolidated }) {
  const t = summary.totals;
  const locRevenue = summary.revenue_breakdown.filter((r) => r.key !== "management_revenue");
  const locRevenueTotal = locRevenue.reduce((a, r) => a + r.value, 0);
  return (
    <div className="bg-brand-surface border border-brand-border" data-testid="pnl-statement">
      <div className="px-6 pt-6 pb-2">
        <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">Profit &amp; Loss</p>
        <p className="font-serif text-xl text-brand-ink mt-1">Full statement</p>
      </div>
      <table className="w-full text-sm">
        <tbody>
          <Row header label="Revenue" />
          {locRevenue.map((r) => <Row key={r.key} indent label={r.label} value={r.value} />)}
          <Row bold label={consolidated ? "Location Revenue" : "Total Revenue"} value={consolidated ? locRevenueTotal : t.total_revenue} />

          <Row header label="Expenses" />
          {summary.expense_breakdown.map((r) => <Row key={r.key} indent label={r.label} value={r.value} />)}
          <Row bold label="Total Expenses" value={t.total_expenses} />

          <Row bold label="Net Ordinary Income" value={t.net_ordinary_income} />
          {!!t.legal_bad_debt && <Row indent neg label="Legal / Bad Debt" value={t.legal_bad_debt} />}
          <Row indent neg label="Corporate Expense Allocation" value={t.corp_expense_allocation} />
          {consolidated ? (
            <>
              <Row bold subtle label="Location Net Income" value={t.location_net_income} />
              <Row header label="Management Deals" />
              <Row indent label="Management Fee" value={t.management_fee} />
              <Row highlight label="Net Income" value={t.net_income} />
              <Row subtle label="Total Revenue (locations + management)" value={t.total_revenue} />
            </>
          ) : (
            <Row highlight label="Net Income" value={t.net_income} />
          )}
        </tbody>
      </table>
    </div>
  );
}
